<div>
  <div class="form-group" [hidden]="!showInputFields">
    <div *ngIf="client" class="address-info-container border">
      <mat-icon>info</mat-icon>
      <p>
        Typ het <strong>volledige adres</strong> in het eerste veld (straat) en
        <strong>selecteer de correcte optie</strong>, de andere velden worden
        automatisch aangevuld
      </p>
    </div>
    <div class="d-flex">
      <mat-form-field
        appearance="outline"
        class="padding-right flexer"
        style="width: 20%"
      >
        <mat-label>Straat</mat-label>
        <input
          matInput
          [placeholder]="'Bv: ' + DEFAULT_ADDRESS"
          autocorrect="off"
          autocapitalize="off"
          spellcheck="off"
          type="text"
          #search
          [formControl]="searchControl"
          (blur)="lineCheck()"
          [required]="showInputFields"
        />
      </mat-form-field>

      <mat-form-field appearance="outline" class="padding-right flexer">
        <mat-label>Nummer</mat-label>
        <input
          #numberField
          matInput
          placeholder="Nummer"
          [(ngModel)]="number"
          [disabled]="disabled"
          (ngModelChange)="numberChange()"
          [required]="showInputFields"
        />
      </mat-form-field>

      <mat-form-field appearance="outline" class="flexer">
        <mat-label>Bus</mat-label>
        <input
          matInput
          placeholder="Bus"
          [(ngModel)]="bus"
          [disabled]="disabled"
          (ngModelChange)="line1Change()"
        />
      </mat-form-field>
    </div>

    <div class="d-flex">
      <mat-form-field
        appearance="outline"
        class="padding-right"
        style="width: 20%"
      >
        <mat-label>Postcode</mat-label>
        <input
          (ngModelChange)="parseAddressFieldChange($event)"
          [(ngModel)]="this.inputAddress.postalCode"
          [disabled]="disabled"
          matInput
          placeholder="Postcode"
          [required]="showInputFields"
        />
      </mat-form-field>

      <mat-form-field
        appearance="outline"
        class="padding-right"
        style="width: 40%"
      >
        <mat-label>Stad</mat-label>
        <input
          matInput
          placeholder="Stad"
          [(ngModel)]="this.inputAddress.city"
          [disabled]="disabled"
          (ngModelChange)="parseAddressFieldChange($event)"
          [required]="showInputFields"
        />
      </mat-form-field>

      <mat-form-field appearance="outline" style="width: 40%">
        <mat-label>Land</mat-label>
        <input
          matInput
          placeholder="Land"
          [(ngModel)]="this.inputAddress.country"
          [disabled]="disabled"
          (ngModelChange)="parseAddressFieldChange($event)"
          [required]="showInputFields"
        />
      </mat-form-field>
    </div>
  </div>
  <div [hidden]="!showMap">
    <map-view
      [latitude]="latitude"
      [longitude]="longitude"
      [scrollwheel]="true"
      [zoom]="zoom"
    >
      <map-marker [latitude]="latitude" [longitude]="longitude"></map-marker>
    </map-view>
  </div>
</div>
